const updateButtonState = (target,copy,state) => {
    target.innerText = copy;
    target.dataset.state = state;
}

document.querySelectorAll('.zl-product-card__button').forEach(target => {
    target.onclick = (event) => {
          
        const [stateOn,stateOff] = ["clicked","default"];
        const [copyOn,copyOff] = ["added to cart!","add to cart"];
      
        if(event.target.dataset.state === stateOff) {
            updateButtonState(event.target,copyOn,stateOn);
            setTimeout(() => {
                updateButtonState(event.target,copyOff,stateOff);
            },700);
        }
    }
});